import React, { useContext } from 'react';
import { FetchResult, MutationResult } from '@apollo/client';
import {
    AppendStructuredBriefDesignersComponent,
    AppendStructuredBriefDesignersMutation,
    AppendStructuredBriefDesignersMutationVariables,
} from '@99designs/apps/spa/pages/create/mutations/AppendStructuredBriefDesigners.generated';
import { BriefContext } from '@99designs/brief';

interface Props {
    children: (
        appendStructuredBriefDesigners: (
            variables: AppendStructuredBriefDesignersMutationVariables
        ) => Promise<void | FetchResult<AppendStructuredBriefDesignersMutation>>,
        result: MutationResult
    ) => React.ReactElement;
}

const AppendStructuredBriefDesigners = ({ children }: Props) => {
    const { brief } = useContext(BriefContext);
    const designerIds = brief.designers.map((d) => d.id);
    return (
        <AppendStructuredBriefDesignersComponent>
            {(mutation, result) => {
                return children((variables) => {
                    const variablesDesignerIds =
                        typeof variables.designerIds === 'number'
                            ? [variables.designerIds]
                            : variables.designerIds;

                    return mutation({
                        variables,
                        optimisticResponse: designerIds
                            ? ({
                                  appendStructuredBriefDesigners: {
                                      id: variables.id,
                                      __typename: 'StructuredBrief',
                                      designers: designerIds
                                          .concat(variablesDesignerIds.map((id) => id.toString()))
                                          .map((id) => ({
                                              id,
                                              __typename: 'User',
                                          })),
                                      designersWithSource: brief.designersWithSource
                                          .map((d) => ({
                                              __typename: 'DesignerWithSource',
                                              ...d,
                                          }))
                                          .concat(
                                              variablesDesignerIds.map(() => ({
                                                  __typename: 'DesignerWithSource',
                                                  source: variables.source,
                                              }))
                                          ),
                                  },
                              } as AppendStructuredBriefDesignersMutation)
                            : undefined,
                    });
                }, result);
            }}
        </AppendStructuredBriefDesignersComponent>
    );
};

export default AppendStructuredBriefDesigners;
